// import {
//     getAccessToken,
//     setAccessToken,
//     removeAccessToken
// } from "@/utils/accessToken";
const state = {
    shopId:'',
    positionId:'',
    languageType:'zh',
};
const mutations = {
    SET_LANGUAGE: (state, languagType) => {
        state.languageType = languagType;
    },
    SET_SHOPID: (state, shopId) => {
        state.shopId = shopId;
    },
    SET_POSITION: (state, positionId) => {
        state.positionId = positionId;
    },
}
const actions={
    language({commit},userInfo) {
        // console.log("userInfo",userInfo)
        return new Promise((resolve) => {
            commit("SET_LANGUAGE", userInfo.lang);
            resolve();
        });
    },
    positionId({commit},userInfo) {
        // console.log('positionId',userInfo)
        return new Promise((resolve) => {
            commit("SET_POSITION", userInfo.id);
            resolve();
        });
    },
    shopId({commit},userInfo) {
        // console.log('SET_SHOPID',userInfo)
        return new Promise((resolve) => {
            commit("SET_SHOPID", userInfo.id);
            resolve();
        });
    },
}
export default {namespaced: true, state,mutations,actions};
